import React, { useEffect } from 'react';
import { Button, Input } from 'reactstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { MatrixDiscountContainer, MatrixDiscountTable } from './styled';
import { Controller, useForm } from 'react-hook-form';

const DiscountMatrixTable = ({
  discounts = [],
  onAddDiscount,
  onRemoveDiscount,
  onDiscountChange,
  onUpdatedDiscountMatrix = () => {}
}) => {
  const { control, setValue } = useForm({
    defaultValues: { discounts }
  });

  useEffect(() => {
    setValue(
      'discounts',
      discounts.map((discount) => ({
        minQuantity: discount?.minQuantity || 0,
        maxQuantity: discount?.maxQuantity || 0,
        discount: discount?.discount || 0
      }))
    );
    onUpdatedDiscountMatrix(discounts);
  }, [discounts, setValue]);

  useEffect(() => {
    if (discounts.length !== 0) {
      validateDiscounts(discounts);
    }
  }, [discounts]);

  const validateDiscounts = () => {
    for (let i = 0; i < discounts.length; i++) {
      const current = discounts[i];
      const next = discounts[i + 1];

      if (current.minQuantity < 0) {
        console.warn(`Linha ${i + 1}: Quantidade mínima deve ser maior que 0`);
        return false;
      }
      if (current.discount < 0 || current.discount > 100) {
        console.warn(`Linha ${i + 1}: Desconto deve estar entre 0 e 100%`);
        return false;
      }
      if (
        i < discounts.length - 1 &&
        current.maxQuantity &&
        next.minQuantity <= current.maxQuantity
      ) {
        console.warn(`Linha ${i + 1}: Intervalos não podem se sobrepor`);
        return false;
      }
    }
    return true;
  };

  const handleQuantityChange = (index, field, value) => {
    const updatedValue = parseInt(value, 10);
    onDiscountChange(index, field, updatedValue);
  };

  return (
    <MatrixDiscountContainer>
      <MatrixDiscountTable>
        <thead>
          <tr>
            <th>Tipo</th>
            <th>
              <div className="discount_fields_description">
                <span>Quantidade</span>
              </div>
            </th>
            <th>
              <div className="discount_fields_description">
                <span>Desconto (%)</span>
              </div>
            </th>
            <th className="discount_columns_actions_wrapper">
              {discounts.length < 6 && (
                <Button color="success" size="sm" onClick={onAddDiscount}>
                  <FaPlus size={12} />
                </Button>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {discounts.map((discount, index) => (
            <tr key={index}>
              <td>{index === discounts.length - 1 ? 'Acima de' : 'Entre'}</td>
              <td>
                <div className="discount_input_wrapper_all">
                  <div className="discount-input-wrapper">
                    <Controller
                      control={control}
                      name={`discounts[${index}].minQuantity`}
                      defaultValue={discount?.minQuantity ?? 0}
                      render={() => (
                        <Input
                          type="number"
                          min="0"
                          value={discount?.minQuantity ?? 0}
                          onChange={(e) => {
                            handleQuantityChange(
                              index,
                              'minQuantity',
                              e.target.value
                            );
                          }}
                        />
                      )}
                    />
                    <span> - </span>
                    {index < discounts.length - 1 && (
                      <Controller
                        control={control}
                        name={`discounts[${index}].maxQuantity`}
                        defaultValue={discount?.maxQuantity ?? 0}
                        render={() => (
                          <Input
                            type="number"
                            value={discount?.maxQuantity ?? 0}
                            onChange={(e) =>
                              handleQuantityChange(
                                index,
                                'maxQuantity',
                                e.target.value
                              )
                            }
                          />
                        )}
                      />
                    )}
                  </div>
                </div>
              </td>
              <td>
                <div className="discount_input_wrapper_all">
                  <div className="discount-input-wrapper">
                    <Controller
                      control={control}
                      name={`discounts[${index}].discount`}
                      defaultValue={discount?.discount ?? 0}
                      render={() => (
                        <Input
                          type="number"
                          max="100"
                          value={discount?.discount ?? 0}
                          onChange={(e) =>
                            handleQuantityChange(
                              index,
                              'discount',
                              e.target.value
                            )
                          }
                        />
                      )}
                    />
                  </div>
                </div>
              </td>
              <td className="discount_rows_actions_wrapper">
                {discounts.length !== 0 && (
                  <Button
                    color="danger"
                    size="sm"
                    onClick={() => onRemoveDiscount(index)}
                  >
                    <FaTrash size={12} />
                  </Button>
                )}
              </td>
            </tr>
          ))}
          {discounts.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center">
                Nenhum desconto cadastrado
              </td>
            </tr>
          )}
        </tbody>
      </MatrixDiscountTable>
    </MatrixDiscountContainer>
  );
};

export default DiscountMatrixTable;
